import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { signOutUser } from '../firebase';
import { useUser } from '../contexts/UserContext';
import { LogOut, User, Building2, Users, Shield, CheckCircle, Mail } from 'lucide-react';

const Navbar = ({ user }) => {
  const location = useLocation();
  const { isSuperAdmin, userRole } = useUser();

  const navItems = [
    { path: '/', label: 'Dashboard', icon: Building2 },
    { path: '/organisational-units', label: 'Organisational Units', icon: Building2 },
    { path: '/access-request', label: 'Access Request', icon: Users },
    { path: '/role-delegation', label: 'Role Request', icon: Shield },
    // { path: '/role-verification', label: 'Role Verification', icon: CheckCircle }, // Commented out per cleanup request
  ];

  // Add admin-only items - ONLY show for David (strict email check only)
  // This menu should ONLY be visible to David, not other super admins
  const isDavid = user && (
    user.email === 'david@entwinedsignage.com.au' || 
    user.email === 'david.joss@entwined.com.au'
  );
  
  if (isDavid) {
    navItems.push({ path: '/admin/customer-admins', label: 'Customer Admins', icon: Mail });
  }

  const handleSignOut = async () => {
    try {
      await signOutUser();
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <nav className="bg-white shadow-md border-b border-gray-200">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center space-x-8">
            <Link to="/" className="flex items-center space-x-3">
              <img 
                src="/entwined-logo.png" 
                alt="Entwined" 
                className="h-16 w-auto"
              />
              <span className="text-xl font-bold text-primary-600">
                Admin Manager
              </span>
            </Link>
            
            <div className="hidden md:flex space-x-6">
              {navItems.map((item) => {
                const Icon = item.icon;
                const isActive = location.pathname === item.path;
                
                return (
                  <Link
                    key={item.path}
                    to={item.path}
                    className={`flex items-center space-x-2 px-3 py-2 rounded-md text-sm font-medium transition-colors ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                    }`}
                  >
                    <Icon size={16} />
                    <span>{item.label}</span>
                  </Link>
                );
              })}
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <User size={16} className="text-gray-500" />
              <span className="text-sm text-gray-700">{user.email}</span>
            </div>
            
            <button
              onClick={handleSignOut}
              className="flex items-center space-x-2 px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors"
            >
              <LogOut size={16} />
              <span>Sign Out</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 